<template>
  <v-app>
    <portal-sysbar></portal-sysbar>
    <div class="main-content">
      <portal-aside></portal-aside>
      <portal-title :title="$t('message.aside.magic', { value: 'default' })"></portal-title>
      <portal-breadcumb></portal-breadcumb>

      <div class="content">
        <v-row class="fixed">
          <v-col class="d-flex" cols="12" sm="2">
            <v-autocomplete :items="ecmList" :label="'ECM'" item-value="company" item-text="name" hide-details="auto"
              multiple outlined v-model="ecms" dense @change="filterGroupByECM">
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">{{ item.name }}</span>
                <span v-if="index === 1" class="grey--text caption">
                  (+{{ ecms.length - 1 }} )
                </span>
              </template>
            </v-autocomplete>
          </v-col>

          <v-col class="d-flex" cols="12" sm="2">
            <v-autocomplete :items="assetList" :label="$t('message.pageKm.loco', { value: 'default' })"
              item-value="asset" item-text="asset" hide-details="auto" multiple outlined dense v-model="assets"
              @change="filterGroupByAsset">
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">{{ item.asset }}</span>
                <span v-if="index === 1" class="grey--text caption">
                  (+{{ assets.length - 1 }} )
                </span>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col class="d-flex pt-0" cols="12" sm="2">
            <v-switch v-model="showExpired" inset :label="$t('message.dispoc.past', { value: 'default' })"
              hide-details="auto" outlined dense></v-switch>
          </v-col>
          <v-col class="d-flex justify-end">
            <v-btn class="mr-2" color="#CCD2D5" @click="loadSignalement()"><v-icon>mdi-plus</v-icon>
              {{ $t("message.magic.sr", { value: "default" }) }}</v-btn>
            <v-btn color="#CCD2D5" @click="loadKm()"><v-icon>mdi-plus</v-icon>
              {{ $t("message.magic.mileage", { value: "default" }) }}</v-btn>
          </v-col>
        </v-row>
        <portal-loading :show="showkm"></portal-loading>
        <portal-loading :show="showsr"></portal-loading>

        <portal-timeline v-if="isMounted" class="pt-4" :reload="reload" :filter="filter" :items="items"
          :buildItem="buildItem" :showExpired="showExpired" :showKpi="true"></portal-timeline>
        <div class="mt-5">
          <ul>
            <li>
              <img src="ACTIVE.png" width="20" />
              {{ $t("message.assetStatus.operating", { value: "default" }) }}
            </li>
            <li>
              <img src="ACTIVE.png" class="blink" width="20" />
              {{
                $t("message.assetStatus.limitedUse", {
                  value: "default",
                })
              }}
            </li>
            <li>
              <img src="maintenance.png" width="20" />
              {{ $t("message.assetStatus.maintenance", { value: "default" }) }}
            </li>
            <li>
              <img src="BLOCKED.png" width="20" />
              {{ $t("message.assetStatus.blocked", { value: "default" }) }}
            </li>
            <li>
              <img src="OFF.png" width="20" />
              {{ $t("message.aside.unleased", { value: "default" }) }}
            </li>
          </ul>
        </div>

        <div class="mt-5 intervention-legend">
          <div>
            <div class="intervention-legend-shape intervention-planned"></div>
            <span class="intervention-legend-text">Intervention planned</span>
          </div>
          <div>
            <div class="intervention-legend-shape intervention-ongoing"></div>
            <span class="intervention-legend-text">Intervention on going</span>
          </div>
          <div>
            <div class="intervention-legend-shape intervention-done"></div>
            <span class="intervention-legend-text">Intervention done</span>
          </div>
          <div>
            <div class="intervention-legend-shape poi"></div>
            <span class="intervention-legend-text">{{ $t("message.poi.workshop", { value: "default" }) }}</span>
          </div>
          <div v-if="getterCurrentClient == 'VFLI'">
            <div class="intervention-legend-shape captrain-items"></div>
            <span class="intervention-legend-text">Train Plan</span>
          </div>
        </div>

      </div>
    </div>


    <v-dialog v-model="signalDialog" width="700" scrollable overlay-color="#fff" overlay-opacity="0.5">
      <portal-signalement :assets="getUpdateLoc()" :customer="getterCurrentClient" :user="getterContact"
        v-on:srClose="closeSr"></portal-signalement>
    </v-dialog>

    <v-dialog v-model="kmDialog" width="700" scrollable overlay-color="#fff" overlay-opacity="0.5">
      <portal-km v-on:kmClose="closeKm" :assets="getUpdateLoc()" :customer="getterCurrentClient"
        :user="getterContact.mail"></portal-km>
    </v-dialog>
    <!-- int dialog-->
  </v-app>
</template>

<script>
import PortalSysbar from "@/components/PortalSysbar";
import PortalAside from "@/components/PortalAside";
import PortalTitle from "@/components/PortalTitle";
import PortalBreadcumb from "@/components/PortalBreadcumb";
import PortalTimeline from "@/components/PortalTimeline";
import PortalSignalement from "@/components/PortalSignalement";
import PortalKm from "@/components/PortalKm.vue";
import { mapActions, mapGetters } from "vuex";
import {
  formatMagicDate,
  getDefaultPeriod,
  formatTimelinePoiToolTipTime,
  isDateRangeOverlapping,
  dateBetween,
  parseStringDate
} from "@/shared/DateHelper";
import CascService from "@/services/CascService";
import PortalLoading from "@/components/PortalLoading.vue";
import { getSrIcon, mergeAffRanges } from "@/shared/Helper";
import CoreService from "@/services/CoreService";
export default {
  watch: {
    getterCurrentClient: function () {
      this.initAssetList();
      this.rebuildAff()
    },
  },
  created() {
    this.classNameByStatus = new Map([
      ["WSCH", "intervention-planned"],
      ["WAPPR", "intervention-planned"],
      ["WPCOND", "intervention-planned"],
      ["CLOSE", "intervention-done"],
      ["COMP", "intervention-done"],
      ["INPRG", "intervention-ongoing"],
      ["REVIEWED", "intervention-done"],
      ["WCOE", "intervention-planned"],
      ["WMATL", "intervention-planned"],
      ["APPR", "intervention-planned"],
      ["CA", "intervention-done"],
      ["NOTPERF", "intervention-done"],
      ["CAN", "intervention-done"],
    ]);
  },
  methods: {
    ...mapActions("carpet", {
      actionGetAgreements: "loadAgreements",
      actionGetAssets: "loadAssets",
      actionGetSrs: "loadSrs",
      actionGetWos: "loadWos",
    }),

    loadChat() {
      this.dialog = true;
    },

    getUpdateLoc() {
      return this.getterAssets.filter((a) => a.leasedState == 'leased')
    },

    //load Service request dialog form
    loadSignalement() {
      this.reload = "";
      this.signalDialog = true;
    },

    //load Asset meters dialog form
    loadKm() {
      this.reload = "";
      this.kmDialog = true;
    },

    closeKm() {
      this.kmDialog = false;
      this.rebuildAff()
    },

    async initAssetList() {
      await this.actionGetAssets(
        {
          customer: this.getterCurrentClient,
          start: getDefaultPeriod().start,
          end: getDefaultPeriod().end
        });
      this.assetList = this.getterAssets;
      this.assetList.forEach(a => {
        if ([
          "MGW000",
          "MGWF",
          "MGWF-1",
          "MGWHU"
        ].includes(a.ecmCode)) {
          a.ecmName = "AKIEM MAINTENANCE & SERVICES";
        }
      });

      this.ecmList = this.assetList.map(a => ({
        company: a.ecmCode,
        name: a.ecmName
      }));
    },

    closeSr(value) {
      this.signalDialog = false;
      if (value == "success") {
        this.reload = "sr";

      }
      this.rebuildAff()
    },

    //filterByAsset
    filterGroupByAsset() {
      this.filter = this.assets;
    },

    rebuildAff() {
      let assets = this.getterAssets.map((a) => a.asset).filter((value, index, array) => array.indexOf(value) === index);
      this.affItems = []
      for (let i = 0; i < assets.length; i++) {
        let asset = assets[i];
        let aff = this.getterAssets.filter((a) => a.asset == asset).map((a) => ({
          //id: i + ,
          end: a.endDate,
          start: a.startDate,
          type: "background",
          group: asset,
          className: "aff"
        }))
        aff = mergeAffRanges(aff)
        this.affItems.push({
          "asset": asset,
          "leasedRange": aff
        })
        this.items = this.items.concat(aff)
      }
    },

    //filterByAsset
    filterGroupByECM() {
      let list = this.ecms;
      this.assets = [];

      if (list.length > 0) {
        let filterList = this.getterAssets.filter(function (item) {
          return list.find((filteritem) => filteritem == item.maintainer.company);
        });
        this.assetList = filterList;
      } else {
        this.assetList = this.getterAssets;
      }
      this.filter = this.assetList.map((e) => {
        return e.assetnum;
      });
    },


    //method to create timeline group (assets)
    async buildItem(state) {
      if (state == "sr") {
        this.showsr = true;
        //this.items.splice(0, this.items.length);
        let payload = {
          customer: this.getterCurrentClient,
          start: getDefaultPeriod().start,
          end: getDefaultPeriod().end,
        };
        if (this.getterContact.internal) {
          payload.scope = "internal";
        } else {
          payload.scope = "external";
        }
        await this.actionGetSrs(payload);
        this.popSr(this.getterSrs);

        this.items = this.srItems.concat(this.woItems).concat(this.poi);
        this.showsr = false;
      }
      await this.rebuildAff()
      if (state == "all") {
        await this.buildSr();
        await this.buildWo();
        //await this.getPoi();
        await this.getCaptrainItems();
      }
      await this.rebuildAff()
      this.isMounted = true;
    },
    //build sr
    async buildSr() {
      this.srloading = true;

      if (this.getterSrs.length == 0) {
        let payload = {
          customer: this.getterCurrentClient,
          start: getDefaultPeriod().start,
          end: getDefaultPeriod().end,
        };
        if (this.getterContact.internal) {
          payload.scope = "internal";
        } else {
          payload.scope = "external";
        }
        await this.actionGetSrs(payload);
      }

      this.popSr(this.getterSrs);

      this.items = this.srItems.concat(this.woItems);
      this.showsr = false;
    },

    popSr(srs) {
      this.srItems.splice(0, this.srItems.length);

      if (srs.length > 0) {
        for (var i = 0; i < srs.length; i++) {
          let sr = srs[i];
          let ranges = this.affItems.filter(elt => (elt.asset == sr.assetnum));
          if (ranges.length > 0) {
            if (ranges[0].leasedRange.find(elt => (dateBetween(parseStringDate(sr.reportdate),
              parseStringDate(elt.start), parseStringDate(elt.end)))) == undefined) {
              continue
            }
          }
          if (sr?.reportdate != null) {
            this.srItems.push({
              id: sr?.ticketid,
              ticketid: sr?.ticketid,
              ldkey: sr?.ticketuid,
              start: sr.reportdate,
              reportdate: sr.reportdate,
              priority: sr.priority,
              content: this.getIcon(sr, this.getterContact.internal),
              description: sr.description,
              title: sr.title,
              status: sr.status,
              srtype: sr.type,
              reportedby: sr.reportedby,
              location: sr.location,
              group: sr.assetnum,
              assetnum: sr.assetnum,
              subgroup: "sign",
              subgroupOrder: 0,
              className: "sign",
            });
          }
        }
      }
    },

    getIcon(sr, internal) {
      return getSrIcon(sr, internal);
    },

    //build wo
    async buildWo() {
      this.woItems.splice(0, this.woItems.length);
      this.showkm = true;

      if (this.getterWos.length == 0) {
        await this.actionGetWos({
          customer: this.getterCurrentClient,
          start: getDefaultPeriod().start,
          end: getDefaultPeriod().end,
        });
      }


      for (var i = 0; i < this.getterWos.length; i++) {
        let workorder = this.getterWos[i];
        let ranges = this.affItems.filter(elt => (elt.asset == workorder.topLevel));
        if (ranges.length > 0) {
          if (ranges[0].leasedRange.find(elt => (isDateRangeOverlapping(
            [workorder.startdate, workorder.enddate], [elt.start, elt.end]))) == undefined) {
            continue
          }
        }

        this.woItems.push({
          workorder: workorder,
          id: workorder.wonum,
          start: workorder.startdate,
          end:
            workorder.enddate === null
              ? getDefaultPeriod().end
              : workorder.enddate,
          group: workorder.topLevel,
          subgroup: "int",
          subgroupOrder: 1,
          className: this.getClassName(workorder.status),
        });
      }

      this.items = this.srItems.concat(this.woItems);
      this.showkm = false;
    },

    async getPoi() {
      this.poi = [];
      let locos = this.getterAssets.map(a => a.assetnum);
      let payload = { locomotives: locos }
      await CascService.findLocoPoi(payload).then(response => {
        if (response.data.length > 0) {
          let i = 0;
          let data = [];

          // should always begin with an entry to workshop
          while (response.data[0].action != "enter") {
            response.data.splice(0, 1);
          }

          let dataLength = response.data.length;
          while (i < dataLength - 1) {
            // valid data : entry then exit of a loco 
            if (response.data[i].action == "enter" && response.data[i + 1].action == "exit"
              && Date.parse(response.data[i].__time) < Date.parse(response.data[i + 1].__time)
              && response.data[i].locomotive == response.data[i + 1].locomotive) {
              data.push(response.data[i]);
              data.push(response.data[i + 1]);
              i += 2;
            }
            else if (i < dataLength - 1) {
              // we expect entry first so delete exit data
              if (response.data[i].action == "exit") {
                response.data.splice(i, 1);
              }
              // successive entries of same loco : we delete second
              else if (response.data[i].action == "enter" && response.data[i + 1].action == "enter"
                && response.data[i].locomotive == response.data[i + 1].locomotive) {
                response.data.splice(i + 1, 1);
              }
              // successive entries with different locos : we delete first
              else if (response.data[i].action == "enter" && response.data[i + 1].action == "enter"
                && response.data[i].locomotive != response.data[i + 1].locomotive) {
                response.data.splice(i, 1);
              }
              // unknown cases we continue
              else {
                i += 2;
              }
            }
            dataLength = response.data.length;

          }

          for (i = 0; i < data.length - 1; i += 2) {
            this.poi.push({
              id: i,
              end: data[i + 1].__time.substring(0, data[i + 1].__time.length - 1) + "+00:00",
              start: data[i].__time.substring(0, data[i].__time.length - 1) + "+00:00",
              type: "background",
              group: data[i].locomotive,
              className: "poi poi" + i / 2,
              city: data[i].city,
            });

          }

          this.items = this.items.concat(this.poi);
          return data;
        }
      }).catch(() => {
        this.poi = [];
      });
    },

    async getCaptrainItems() {
      this.captrainItems = [];
      if (this.getterCurrentClient == 'VFLI') {
        await CoreService.findCaptrainItems().then(response => {
          if (response.data.length > 0) {
            let i = 0;
            let data = response.data;

            for (i = 0; i < data.length; i++) {
              this.captrainItems.push({
                id: "VFLI" + i,
                end: data[i].endDate,
                start: data[i].startDate,
                startLocation: data[i].startLocation,
                endLocation: data[i].endLocation,
                group: data[i].locomotive,
                subgroup: "captrain",
                subgroupOrder: 2,
                className: "captrain-items",
              });

            }

            this.items = this.items.concat(this.captrainItems);
            return data;
          }
        }).catch(() => {
          this.captrainItems = [];
        });
      }
    },

    getClassName(status) {
      return this.classNameByStatus.get(status);
    },

    appendPoiTooltip() {
      let j;
      let element;
      for (j = 0; j < this.poi.length; j++) {
        element = document.getElementsByClassName(this.poi[j].className.substring(4))[0];
        if (element) {
          element.title = this.$t("message.poi.workshop", { value: "default" }) + " "
            + this.poi[j].city + "\n" + this.$t("message.poi.entry", { value: "default" }) + " "
            + formatMagicDate(this.poi[j].start, this.$i18n.locale) + " "
            + this.$t("message.poi.at", { value: "default" }) + " "
            + formatTimelinePoiToolTipTime(this.poi[j].start, this.$i18n.locale)
            + "\n" + this.$t("message.poi.exit", { value: "default" }) + " "
            + formatMagicDate(this.poi[j].end, this.$i18n.locale) + " "
            + this.$t("message.poi.at", { value: "default" }) + " "
            + formatTimelinePoiToolTipTime(this.poi[j].end, this.$i18n.locale);
        }
      }
    },

  },
  name: "MagicPage",
  title: "My MINT",

  components: {
    PortalSysbar,
    PortalAside,
    PortalTitle,
    PortalBreadcumb,
    PortalTimeline,
    PortalSignalement,
    PortalKm,
    PortalLoading,
  },
  data() {
    return {
      reload: "",
      showExpired: true,
      filter: [],
      dialog: false,
      alert: false,
      atype: "",
      message: "",
      signalDialog: false,
      kmDialog: false,
      assets: [],
      assetList: [],
      showsr: false,
      showkm: false,
      items: [],
      srItems: [],
      woItems: [],
      poi: [],
      affItems: [],
      isMounted: false,
      ecmList: [],
      ecms: [],
      captrainItems: [],
    };
  },

  computed: {
    ...mapGetters("auth", {
      getterCurrentClient: "getCurrentClient",
      getterContact: "getUserContact",
    }),

    ...mapGetters("carpet", {
      getterAssets: "getAssets",
      getterAgreements: "getAgreements",
      getterSrs: "getSrs",
      getterWos: "getWos",
    }),


  },
  mounted() {
    this.initAssetList();
    this.buildItem("all");

  },
};
</script>

<style scoped>
@keyframes blink {
  50% {
    opacity: 0;
  }
}


.blink {
  animation: blink 1s step-start 0s infinite;
}

.fixed {
  position: fixed;
  background-color: #fff;
  z-index: 5;
  right: 70px;
  left: 310px;
}

ul {
  list-style: none;
  padding-left: 0px;
}

li {
  display: inline;
  margin-right: 5px;
  text-align: center;
}

.intervention-legend {
  display: flex !important;
  justify-content: flex-start;
  align-items: baseline;
  flex-wrap: wrap;
}

.intervention-legend-shape {
  height: 10px;
  width: 30px;
  display: inline-block;
}

.intervention-planned {
  background: #CCD2D5;
  border: #CCD2D5;
}

.poi {
  background: rgba(132, 197, 237, 0.4);
}

.intervention-done {
  background: #003441;
  border: #003441;
}

.intervention-ongoing {
  background: #eebb07;
  border: #eebb07;
}

.intervention-legend-text {
  margin: 0 30px 0 5px;
}

.captrain-items {
  background: rgba(160, 213, 197);
}
</style>
